import { createApiModule } from 'hooks/fetch';
const MODULE_NAME = 'Spaces';
const createApiModuleActions = createApiModule(MODULE_NAME);
// Reducers
const SPACES = 'spaces';
const SPACES_INFO = 'spaces';
const reducers = {
    SPACES,
    SPACES_INFO,
};
// Api actions
export const GET_SPACES_REQUEST = 'GET_SPACES_REQUEST';
export const GET_SPACES_SUCCESS = 'GET_SPACES_SUCCESS';
export const GET_SPACES_FAILURE = 'GET_SPACES_FAILURE';
export const GET_SPACE_INFO_REQUEST = 'GET_SPACE_INFO_REQUEST';
export const GET_SPACE_INFO_SUCCESS = 'GET_SPACE_INFO_SUCCESS';
export const GET_SPACE_INFO_FAILURE = 'GET_SPACE_INFO_FAILURE';
export const SET_SPACE_NAME_SUCCESS = 'Fetch.Spaces.SET_SPACE_NAME_SUCCESS';
export const ACCEPT_SPACE_INVITE_SUCCESS = 'ACCEPT_SPACE_INVITE_SUCCESS';
export const ACCEPT_SPACE_INVITE_REQUEST = 'ACCEPT_SPACE_INVITE_REQUEST';
export const ACCEPT_SPACE_INVITE_FAILURE = 'ACCEPT_SPACE_INVITE_FAILURE';
export const GET_SPACE_INVITE_DETAILS_REQUEST = 'GET_SPACE_INVITE_DETAILS_REQUEST';
export const GET_SPACE_INVITE_DETAILS_SUCCESS = 'GET_SPACE_INVITE_DETAILS_SUCCESS';
export const GET_SPACE_INVITE_DETAILS_FAILURE = 'GET_SPACE_INVITE_DETAILS_FAILURE';
export const GET_INVITES_FOR_SPACE_REQUEST = 'GET_INVITES_FOR_SPACE_REQUEST';
export const GET_INVITES_FOR_SPACE_SUCCESS = 'GET_INVITES_FOR_SPACE_SUCCESS';
export const GET_INVITES_FOR_SPACE_FAILURE = 'GET_INVITES_FOR_SPACE_FAILURE';
export const EDIT_SPACE_INFO = 'EDIT_SPACE_INFO';
export const DELETE_SPACE_REQUEST = 'DELETE_SPACE_REQUEST';
export const DELETE_SPACE_SUCCESS = 'DELETE_SPACE_SUCCESS';
export const DELETE_SPACE_FAILURE = 'DELETE_SPACE_FAILURE';
export const CREATE_SPACE_SUCCESS = 'CREATE_SPACE_SUCCESS';
// When the user selects a space
export const SELECTED_SPACE = 'SELECTED_SPACE';
// When the space actually changes (they might select the space they are already in)
export const SWITCHED_SPACE = 'SWITCHED_SPACE';
export const FETCH_SPACES = 'FETCH_SPACES';
export const DISMISSED_SPACE_NOT_PREMIUM_ERROR = 'DISMISSED_SPACE_NOT_PREMIUM_ERROR';
export const SPACE_SWITCHED_MODAL_VISIBLE_FOR_TIME = 3000;
const getSpaces = [GET_SPACES_REQUEST, GET_SPACES_SUCCESS, GET_SPACES_FAILURE];
const getSpaceInfo = [
    GET_SPACE_INFO_REQUEST,
    GET_SPACE_INFO_SUCCESS,
    GET_SPACE_INFO_FAILURE,
];
const createSpace = createApiModuleActions('CREATE_SPACE');
const setSpaceName = createApiModuleActions('SET_SPACE_NAME');
const joinSpace = createApiModuleActions('JOIN_SPACE');
const setAccountSpace = createApiModuleActions('SET_ACCOUNT_SPACE');
const deleteSpaceMember = createApiModuleActions('DELETE_SPACE_MEMBER');
const rejectSpaceInvite = createApiModuleActions('REJECT_SPACE_INVITE');
const acceptSpaceInvite = createApiModuleActions('ACCEPT_SPACE_INVITE');
const apiEvents = {
    getSpaces,
    getSpaceInfo,
    createSpace,
    setSpaceName,
    joinSpace,
    setAccountSpace,
    deleteSpaceMember,
    rejectSpaceInvite,
    acceptSpaceInvite,
};
export const SET_SHOW_SPACE_LOCK = 'SET_SHOW_SPACE_LOCK';
export { apiEvents, reducers };
export default { apiEvents, reducers };
